import axios from '@/utils/request'

/**
 * 登陆
 */
const toLogin = data => axios({
  url: '/admin/login',
  method: 'post',
  data
})

/**
 * 管理员列表
 */
const getAuthorityList = (params, options) => axios({
  url: 'admin',
  params,
  options
})

/**
 * 新增管理员
 */
const addAdmin = (data) => axios({
  url: 'admin',
  method: 'post',
  data
})

/**
 *
 */
const setAdmin = (data) => axios({
  url: 'admin',
  method: 'put',
  data
})

/**
 * 删除管理员
 */
const deleteAuthority = (data) => axios({
  url: 'admin',
  method: 'delete',
  data
})

/**
 * 身份列表
 */
const getIdentifyList = (params, options) => axios({
  url: 'admin/role',
  params,
  options
})

/**
 * 权限列表
 */
const getPermissionsList = () => axios({
  url: 'admin/permissions'
})

/**
 * 添加身份
 */
const addIdentify = (data) => axios({
  url: 'admin/role',
  method: 'post',
  data
})

/**
 * 删除身份
 */
const deleteIdentify = (uuid) => axios({
  url: `admin/role/${uuid}`,
  method: 'delete'
})

/**
 * 编辑身份
 */
const setIdentify = (data) => axios({
  url: 'admin/role',
  method: 'put',
  data
})

/**
 * 操作日志列表
 */
const getLogList = (params, options) => axios({
  url: 'admin/log',
  params,
  options
})

/**
 * 操作日志列表
 */
export const addMenu = (data) => axios({
  url: 'admin/permissions',
  method: 'post',
  data
})

/**
 * 删除权限
 */
export const deleteMenu = (uuid) => axios({
  url: `admin/permissions/${uuid}`,
  method: 'delete',
})

/**
 * 权限列表 new
 */
export const getMenuNew = (params, options) => axios({
  url: 'admin/permissions/new',
  options,
  params
})

/**
 * 修改菜单
 */
export const setMenu = (data) => axios({
  url: 'admin/permissions',
  method: 'put',
  data
})

export {
  toLogin,
  getAuthorityList,
  deleteAuthority,
  addAdmin,
  setAdmin,
  getIdentifyList,
  getPermissionsList,
  addIdentify,
  deleteIdentify,
  setIdentify,
  getLogList
}
